import { Injectable } from '@angular/core';
import { IPaetepCfGenericMapperService } from '../../interfaces/paetep-cf-generic-mapper.service';
import { DatePickerAnswerConfig } from 'src/app/model/observation/custom-forms/answer-configs/date-picker-answer-config.model';
import { EdlCfAnswerDatePickerModel, EdlCfDatePickerModel, EdlCfGenericModel, MAX_TITLE_LENGTH } from '@edl-development/edl-custom-forms';
import { CustomFormQuestionDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-question-dto.model';
import { CustomFormQuestionType } from 'src/app/model/enum/observations/custom-forms/custom-form-question-type.enum';
import { CustomFormsHelpersService } from '../../custom-forms-helpers/custom-forms-helpers.service';

@Injectable({
    providedIn: 'root'
})
export class PaetepCfDateMapperService implements IPaetepCfGenericMapperService<DatePickerAnswerConfig, EdlCfDatePickerModel, string, EdlCfAnswerDatePickerModel>  {

    constructor(private customFormsHelpersService: CustomFormsHelpersService) { }

    public toEdlModel = (child: CustomFormQuestionDisplayDTO<DatePickerAnswerConfig>): EdlCfDatePickerModel => {
        return {
            title: child.label,
            isRequired: child.required
        }
    }

    public toPaetepModel = ({
        formID, 
        sectionID,
        displayOrder,
        groupOrder,
        question
    } : {
        formID: string, 
        sectionID: string, 
        displayOrder: number,
        groupOrder: number,
        question: EdlCfGenericModel<EdlCfDatePickerModel>
    }): CustomFormQuestionDisplayDTO<DatePickerAnswerConfig> =>  {
        return this.customFormsHelpersService.createCustomFormQuestion<DatePickerAnswerConfig>({
            $type: CustomFormQuestionType.DATE,
            typeID: CustomFormQuestionType.DATE,
            formID,
            sectionID,
            questionID: question?.id ?? '',
            readOnly: false,
            required: question.config.isRequired,
            displayOrder,
            groupOrder,
            label: (question?.config?.title ?? '').substring(0, MAX_TITLE_LENGTH),
            displayLabel: true,
            answerConfig: {
                prefill: ''
            }
        });
    }

    public toEdlAnswer = (answer: string = '', question: CustomFormQuestionDisplayDTO<DatePickerAnswerConfig>) => 
        !!answer ? new Date(answer) : null;

    public toPaetepAnswer = (answer: EdlCfAnswerDatePickerModel, question: CustomFormQuestionDisplayDTO<DatePickerAnswerConfig>) => {
        if (!answer || isNaN(answer.getTime())) return null;

        const year = answer.getFullYear();
        const month = (answer.getMonth() + 1).toString().padStart(2, '0');
        const day = answer.getDate().toString().padStart(2, '0');

        return `${month}/${day}/${year}`;
    }
}
